import { z } from 'zod';
import { FormDataResponse } from '../../../../model/sprievodnyDokument/FormDataResponse';
import { ClientStatus } from '../../../../model/ClientStatus';
import { ObalMaterialu } from '../../../../model/sprievodnyDokument/obalMaterialu/ObalMaterialuFormData';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import getObalMaterialuFormData from '../../../../function/getObalMaterialuFormData';
import Uuid from '../../../../model/Uuid';
import fallback from '../../../../function/zodFallback';

const ObalMaterialuResponse = z.object({
  nazovVygenerovanehoDokumentu: fallback(z.string(), ''),
  zodpovednaInstitucia: fallback(z.string(), ''),
  rezortneCislo: fallback(z.string(), ''),
  typObalu: fallback(z.string(), ''),
  navrh: fallback(z.string(), ''),
  typMaterialu: fallback(z.string(), ''),
  rok: fallback(z.string(), ''),
  nazovMaterialu: fallback(z.string(), ''),
  podnet: fallback(z.string(), ''),
  obsahMaterialu: fallback(z.string(), ''),
  predkladatel: fallback(z.string(), ''),
  miestoDatum: fallback(z.string(), ''),
});

export function mapObalMaterialuVseobecny(rawFormData: string): ObalMaterialu {
  const response = ObalMaterialuResponse.parse(rawFormData);

  return {
    nazovVygenerovanehoDokumentu: response.nazovVygenerovanehoDokumentu,
    zodpovednaInstitucia: response.zodpovednaInstitucia,
    rezortneCislo: response.rezortneCislo,
    typObalu: response.typObalu,
    navrh: response.navrh,
    typMaterialu: response.typMaterialu,
    rok: response.rok,
    nazovMaterialu: response.nazovMaterialu,
    podnet: response.podnet,
    obsahMaterialu: response.obsahMaterialu,
    predkladatel: response.predkladatel,
    miestoDatum: response.miestoDatum,
  };
}

interface ReturnType {
  formDataResponse: FormDataResponse<ObalMaterialu>,
  formDataStatus: ClientStatus,
}

export default (
  type: string,
  year: number,
  index: number,
  sprievodnyDokumentUuid: Uuid,
): ReturnType => {
  const {
    data,
    status,
  } = useClientFetch(
    getObalMaterialuFormData,
    [type, year, index, sprievodnyDokumentUuid],
    [],
  );

  return {
    formDataResponse: data ? {
      formData: mapObalMaterialuVseobecny(data.formData.formData),
      materialDetail: data.materialDetail,
    } : null,
    formDataStatus: status,
  };
};
